<template>
  <div class="w-full fadeIn">
    <div class="flex justify-between items-center">
      <div class="flex items-center pb-2 w-full">
        <button
          class="tab-btn"
          :class="{ 'tab-active': activeTab == '1' }"
          @click="setActiveTab('1')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 512 512"
            style="enable-background:new 0 0 512 512;"
            xml:space="preserve"
            class="btn-icon"
          >
            <g>
              <path
                d="M407,0H105C47.103,0,0,47.103,0,105v302c0,57.897,47.103,105,105,105h302c57.897,0,105-47.103,105-105V105
			C512,47.103,464.897,0,407,0z M256,386c-18.631,0-36.558-2.476-53.333-7.037L142,410l8.976-53.905
			C111.41,330.461,86,290.675,86,246c0-77.32,76.112-140,170-140s170,62.68,170,140S349.888,386,256,386z"
              />
            </g>
          </svg>
          SMS
        </button>
        <button
          class="tab-btn"
          :class="{ 'tab-active': activeTab == '2' }"
          @click="setActiveTab('2')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 512 512"
            style="enable-background:new 0 0 512 512;"
            xml:space="preserve"
            class="btn-icon"
          >
            <g>
              <path
                d="M10.688,95.156C80.958,154.667,204.26,259.365,240.5,292.01c4.865,4.406,10.083,6.646,15.5,6.646
				c5.406,0,10.615-2.219,15.469-6.604c36.271-32.677,159.573-137.385,229.844-196.896c4.375-3.698,5.042-10.198,1.5-14.719
				C494.625,69.99,482.417,64,469.333,64H42.667c-13.083,0-25.292,5.99-33.479,16.438C5.646,84.958,6.313,91.458,10.688,95.156z"
              />
              <path
                d="M505.813,127.406c-3.781-1.76-8.229-1.146-11.375,1.542C416.51,195.01,317.052,279.688,285.76,307.885
				c-17.563,15.854-41.938,15.854-59.542-0.021c-33.354-30.052-145.042-125-208.656-178.917c-3.167-2.688-7.625-3.281-11.375-1.542
				C2.417,129.156,0,132.927,0,137.083v268.25C0,428.865,19.135,448,42.667,448h426.667C492.865,448,512,428.865,512,405.333
				v-268.25C512,132.927,509.583,129.146,505.813,127.406z"
              />
            </g>
          </svg>
          Email
        </button>
      </div>
      <div class="text-right" style="flex-shrink: 0;">
        <button
          class="mb-2 bg-green px-4 py-2 text-white shadow-md rounded-sm font-normal"
          @click="addNewTemplate()"
        >
          Create {{ activeTab == "1" ? "SMS" : "Email" }} Template (c)
        </button>
      </div>
    </div>
    <Table
      ref="templateTable"
      :endpoint="endpoint"
      :tableConfig="tableConfig"
    />
    <VModal name="sms-modal" :click-to-close="false" width="600" height="400">
      <SMSEditor
        :editTemplateObj="editTemplateObj"
        @template-created="templateCreated"
        @discard-sms-modal="hideModal"
      />
    </VModal>
    <VModal
      name="email-modal"
      :click-to-close="false"
      width="70%"
      height="98%"
      class="email-modal"
    >
      <EmailEditor
        :editTemplateObj="editTemplateObj"
        @template-created="templateCreated"
        @discard-sms-modal="hideModal"
      />
    </VModal>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"
import SMSEditor from "@/components/Notification/SMSEditor"
import EmailEditor from "@/components/Notification/EmailEditor"
import { duplicateTemplate } from "@/apis/notification/index"

export default {
  components: { Table, SMSEditor, EmailEditor },
  data() {
    return {
      notyConfig: {
        layout: "bottomLeft",
        animation: {
          open: "slideUp",
          close: "fadeOut",
          progressBar: false,
        },
      },
      editTemplateObj: null,
      endpoint: `${siteConfig.siteURL}notifications/templates?channel_type=1`,
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          classList: "w-1/3",
          path: "name",
        },
        {
          header: { textContent: "Id" },
          path: "id",
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "Created On", sortingParam: "created_on" },
          type: "date",
          path: "created_on",
        },

        {
          header: { textContent: "Duplicate" },
          path: "id",
          type: "button",
          classList:
            "copy-button rounded-sm m-0 flex justify-center items-center",
          buttonText: `<svg xmlns="http://www.w3.org/2000/svg" height="20" fill="grey" viewBox="-40 0 512 512" width="20"><path d="m271 512h-191c-44.113281 0-80-35.886719-80-80v-271c0-44.113281 35.886719-80 80-80h191c44.113281 0 80 35.886719 80 80v271c0 44.113281-35.886719 80-80 80zm-191-391c-22.054688 0-40 17.945312-40 40v271c0 22.054688 17.945312 40 40 40h191c22.054688 0 40-17.945312 40-40v-271c0-22.054688-17.945312-40-40-40zm351 261v-302c0-44.113281-35.886719-80-80-80h-222c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h222c22.054688 0 40 17.945312 40 40v302c0 11.046875 8.953125 20 20 20s20-8.953125 20-20zm0 0"/></svg>`,
          onclick: id => {
            this.requestTemplateDuplication(id)
          },
        },
        {
          header: { textContent: "Edit" },
          path: "/",
          type: "button",
          classList: "rounded-sm m-0 edit-button",
          buttonText: `Edit`,
          onclick: template => {
            this.editTemplate(template)
          },
        },
      ],
    }
  },
  computed: {
    activeTab() {
      if (this.$route.query && this.$route.query.sub_tab) {
        return this.$route.query.sub_tab
      }
      return "1"
    },
  },
  beforeDestroy() {
    document.removeEventListener("keypress", () => this.handleKeypress)
  },
  created() {
    if (!this.$route.query || !this.$route.query.sub_tab) {
      const routeObj = { ...this.$route, query: { ...this.$route.query } }
      routeObj.query.sub_tab = "1"
      this.$router.replace(routeObj).catch(() => {})
    }
  },
  mounted() {
    document.addEventListener("keypress", e => this.handleKeypress(e))
  },
  methods: {
    templateCreated() {
      this.editTemplateObj = null
      this.refreshTable()
    },
    hideModal() {
      this.$modal.hide("sms-modal")
      this.$modal.hide("email-modal")
      this.editTemplateObj = null
    },
    handleKeypress(e) {
      if (
        e.target.nodeName !== "INPUT" &&
        e.target.nodeName !== "TEXTAREA" &&
        e.code === "KeyC"
      ) {
        this.addNewTemplate()
      }
    },
    setActiveTab(tab) {
      this.updateRoute([
        { key: "sub_tab", value: tab },
        { key: "channel_type", value: tab },
      ])
    },
    refreshTable() {
      this.$refs.templateTable.getItems()
    },
    addNewTemplate() {
      if (this.activeTab === "1") {
        this.showSMSModal()
      } else {
        this.showEmailModal()
      }
    },
    editTemplate(template) {
      this.editTemplateObj = template
      /* eslint-disable-next-line eqeqeq */
      if (this.activeTab == "1") {
        this.showSMSModal()
      } else {
        this.showEmailModal()
      }
    },
    requestTemplateDuplication(id) {
      this.$noty.info("Creating a duplicate, please wait", this.notyConfig)
      duplicateTemplate(id)
        .then(res => {
          this.$noty.info(
            `Duplicate template created: ${res.data.name}`,
            this.notyConfig
          )
          this.refreshTable()
        })
        .catch(err => {
          console.error(err)
          this.$noty.error("Failed to duplicate template", this.notyConfig)
        })
    },
    updateRoute(data) {
      const routeObj = { ...this.$route, query: { ...this.$route.query } }

      if (data && Array.isArray(data)) {
        data.forEach(item => {
          if (item.value) {
            routeObj.query[item.key] = item.value
          } else {
            Reflect.deleteProperty(routeObj.query, item.key)
          }
        })
      } else if (data && typeof data === "object") {
        if (data.value) {
          routeObj.query[data.key] = data.value
        } else {
          Reflect.deleteProperty(routeObj.query, data.key)
        }
      }
      this.$router.push(routeObj).catch(() => {})
    },
    showSMSModal() {
      this.$modal.show("sms-modal")
    },
    showEmailModal() {
      this.$modal.show("email-modal")
    },
  },
}
</script>

<style scoped>
.tab-btn {
  display: flex;
  width: 10rem;
  margin: 0 0.5rem;
  padding: 0.5rem 1rem;
  border-bottom: 3px solid transparent;
  border-radius: 0px;
  color: #858585;
  background: transparent;
  align-items: center;
  justify-content: center;
}

.btn-icon {
  width: 1.7rem;
  margin-right: 1rem;
  fill: #858585;
}

.tab-active {
  border-bottom: 3px solid #58b4ff;
  color: #58b4ff;
}

.tab-btn:hover,
.tab-btn:focus {
  color: #58b4ff;
}

.tab-active .btn-icon {
  fill: #58b4ff;
}
</style>

<style>
.ed-table-wrapper .copy-button {
  width: 25px;
  width: 100%;
  height: 25px;
  padding: 0;
}

.ed-table-wrapper .edit-button {
  width: 100%;
  padding: 0;
  color: #0000ee;
  font-weight: normal;
}
</style>
